var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading"},[_c('div',{staticClass:"mask"}),_vm._v(" "),_c('div',{staticClass:"loading_con"},[_c('div',{staticStyle:{"padding-top":"10px","padding-bottom":"10px","color":"#409eff","font-weight":"bold"}},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('i'),_vm._v(" "),_c('i'),_vm._v(" "),_c('i'),_vm._v(" "),_c('i'),_vm._v(" "),_c('i')])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24f13976","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Loading.vue
// module id = null
// module chunks = 